import { Component, OnInit } from '@angular/core'
import { ProspectInteraction, ProspectInteractionType, ProspectInteractionTypeLabels, ProspectInteractionTypeIcons } from '@parkupp/core'
import { ProspectingService } from 'src/app/services/prospecting.service'

@Component({
    selector: 'app-admin-prospecting-timeline',
    templateUrl: './admin-prospecting-timeline.component.html',
    styleUrls: ['./admin-prospecting-timeline.component.scss'],
})
export class AdminProspectingTimelineComponent implements OnInit {
    interactions: ProspectInteraction[] = []
    loading = true

    filterType = ''
    filterUser = ''
    filterCompany = ''

    interactionTypeLabels = ProspectInteractionTypeLabels
    interactionTypeIcons = ProspectInteractionTypeIcons
    interactionTypes = Object.values(ProspectInteractionType)

    constructor(private prospecting: ProspectingService) {}

    async ngOnInit(): Promise<void> {
        try {
            this.interactions = await this.prospecting.listAllInteractions()
        } catch (e) {
            console.error('Error loading interactions:', e)
        } finally {
            this.loading = false
        }
    }

    get filteredInteractions(): ProspectInteraction[] {
        const userTerm = this.filterUser.trim().toLowerCase()
        const companyTerm = this.filterCompany.trim().toLowerCase()

        return this.interactions.filter((i) => {
            if (this.filterType && i.type !== this.filterType) return false
            if (userTerm && !(i.denormCreatedByName || '').toLowerCase().includes(userTerm)) return false
            if (companyTerm && !(i.denormProspectName || '').toLowerCase().includes(companyTerm)) return false
            return true
        })
    }

    formatDate(timestamp: any): string {
        if (!timestamp) return '-'
        if (timestamp.toDate) return timestamp.toDate().toLocaleString()
        if (timestamp.seconds) return new Date(timestamp.seconds * 1000).toLocaleString()
        if (typeof timestamp === 'string') return new Date(timestamp).toLocaleString()
        return '-'
    }
}
